import * as React from 'react';
import { I18n } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import { AuthPiece } from 'aws-amplify-react';
import { updateEmailToSendy } from '../../redux/actions/user.action';
import {
  Button,
  FormField,
  FormSection,
  Hint,
  Input,
  InputLabel,
  Link,
  SectionBody,
  SectionFooter,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent,
  SectionHeader,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import { connect } from 'react-redux';

class ConfirmSignUp extends AuthPiece {
  constructor(props) {
    super(props);

    this._validAuthStates = ['confirmSignUp'];
    this.confirm = this.confirm.bind(this);
    this.resend = this.resend.bind(this);
  }

  confirm() {
    const username = this.usernameFromAuthData() || this.inputs.username;
    let { code = '' } = this.inputs;
    code = code.replace(/\s/g, '');
    if (!Auth || typeof Auth.confirmSignUp !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    console.log('this.inputs', this.inputs)
    Auth.confirmSignUp(username, code)
      .then(() => {
        this.changeState('signedUp')
        console.log('username', username)
        this.props.updateEmailToSendy(username)
      })
      .catch((err) => this.error(err));
  }

  resend() {
    const username = this.usernameFromAuthData() || this.inputs.username;
    if (!Auth || typeof Auth.resendSignUp !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    Auth.resendSignUp(username)
      .then(() => console.log('code resent'))
      .catch((err) => this.error(err));
  }

  showComponent(theme) {
    const { hide } = this.props;
    const username = this.usernameFromAuthData();

    if (hide && hide.includes(ConfirmSignUp)) {
      return null;
    }

    return (
      <FormSection theme={theme}>
        <SectionHeader theme={theme}>{I18n.get('Confirm Sign Up')}</SectionHeader>
        <SectionBody theme={theme}>
          <FormField theme={theme}>
            <InputLabel>{I18n.get('Email')} *</InputLabel>
            <Input
              placeholder={I18n.get('Email')}
              theme={theme}
              key="username"
              name="username"
              onChange={this.handleInputChange}
              disabled={username}
              value={username ? username : ''}
            />
          </FormField>

          <FormField theme={theme}>
            <InputLabel>{I18n.get('Confirmation Code')} * (Sent to your email)</InputLabel>
            <Input
              autoFocus
              placeholder={I18n.get('Enter your code')}
              theme={theme}
              key="code"
              name="code"
              autoComplete="off"
              onChange={this.handleInputChange}
            />
            <Hint theme={theme}>
              {I18n.get('Lost your code? ')}
              <Link theme={theme} onClick={this.resend}>
                {I18n.get('Resend Code')}
              </Link>
            </Hint>
          </FormField>
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button theme={theme} onClick={this.confirm}>
              {I18n.get('Confirm')}
            </Button>
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            <Link theme={theme} onClick={() => this.changeState('signIn')}>
              {I18n.get('Back to Sign In')}
            </Link>
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}

export default connect(null, { updateEmailToSendy })(ConfirmSignUp);
